import { InfoBox } from '@flos/react-ui';
import { useHippoText } from '../../../hooks/useHippoText';
import { useRecoilValue } from 'recoil';
import { topConfigContextAtom } from '../../../recoil/atoms/topConfigContextAtom';
import { accountHolderAtom } from '../../../recoil/atoms/accountHolderAtom';

const LandingPageHeaderTable = (): React.JSX.Element => {
    const getHippoText = useHippoText();
    const topConfigContext = useRecoilValue(topConfigContextAtom);
    const { isCVR } = useRecoilValue(accountHolderAtom);

    return (
        <>
            <h3 className="u-text-left">
                {getHippoText('DSS-LANDING-PAGE-FLOW-DESCRIPTION-HEADER')}
            </h3>
            <div className="Box--group Box--group-compact">
                <InfoBox
                    imageUrl={`${topConfigContext?.resourceUrl ?? ''}/images/newsletter.svg`}
                    text={getHippoText('DSS-LANDING-PAGE-FIRST-STEP-DESCRIPTION')}
                    title={getHippoText('DSS-LANDING-PAGE-FIRST-STEP-TITLE')}
                />
                <InfoBox
                    imageUrl={`${topConfigContext?.resourceUrl ?? ''}/images/approval-2.svg`}
                    text={getHippoText(
                        isCVR
                            ? 'DSS-LANDING-PAGE-CVR-SECOND-STEP-DESCRIPTION'
                            : 'DSS-LANDING-PAGE-SECOND-STEP-DESCRIPTION'
                    )}
                    title={getHippoText('DSS-LANDING-PAGE-SECOND-STEP-TITLE')}
                />
                <InfoBox
                    imageUrl={`${topConfigContext?.resourceUrl ?? ''}/images/woman-happy-sign.svg`}
                    text={getHippoText(
                        isCVR
                            ? 'DSS-LANDING-PAGE-CVR-THIRD-STEP-DESCRIPTION'
                            : 'DSS-LANDING-PAGE-THIRD-STEP-DESCRIPTION'
                    )}
                    title={getHippoText('DSS-LANDING-PAGE-THIRD-STEP-TITLE')}
                />
            </div>
        </>
    );
};

export default LandingPageHeaderTable;
